/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import { Col, Row, Switch } from 'antd';
import PropTypes from 'prop-types';
import { featureCategoryValidationSchema } from './featureCategory.schema';
import { DEFAULT_LANG, LANGUAGE_BY_DOMAIN } from '../../../utils/constants';
import {
  addNewFeaturesCategory,
  editFeaturesCategory,
  getAllFeaturesCategory,
} from '../../../redux/featuresCategory/actionCreator';
import { BasicFormWrapper } from '../../styled';
import FormInput from '../../../components/input/input';
import DivBreak from '../../../components/divBreak/DivBreak';
import { Button } from '../../../components/buttons/buttons';

const FeatureCategoryForm = props => {
  const { formData, onCancel } = props;
  const [isMultiLangFlag, setIsMultiLangFlag] = useState(false);
  const categoryLoading = useSelector(state => state.featuresCategory.loading);
  const dispatch = useDispatch();
  useEffect(() => {
    setIsMultiLangFlag(formData?.isMultiLang.includes('true'));
  }, [formData]);
  async function handleFormSubmit(requestData, resetForm) {
    try {
      const transformedCategory = [];
      LANGUAGE_BY_DOMAIN.forEach(langItem => {
        if (requestData.isMultiLang === 'true' || langItem[1] === DEFAULT_LANG.value) {
          transformedCategory.push({
            lang: langItem[1],
            category: requestData[`category${langItem[1]}`],
          });
        }
      });

      const formValue = {
        details: transformedCategory,
      };

      // eslint-disable-next-line no-underscore-dangle
      //   const res = await dispatch(addNewFeaturesCategory(formValue));
      const res = await dispatch(
        requestData?._id ? editFeaturesCategory(requestData?._id, formValue) : addNewFeaturesCategory(formValue),
      );
      if (res?.status) {
        resetForm();
        onCancel();
        getAllFeaturesCategory(dispatch);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }
  return (
    <Formik
      initialValues={formData}
      validationSchema={featureCategoryValidationSchema(isMultiLangFlag)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
        // eslint-disable-next-line no-use-before-define
        handleFormSubmit(values, resetForm);
      }}
      enableReinitialize
    >
      {({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
          <Form>
            <BasicFormWrapper>
              <div className="add-product-block">
                <Row gutter={[16, 16]}>
                  {/* language switcher */}
                  <Col xs={24}>
                    <h4>Translate</h4>
                    <Switch
                      checked={values.isMultiLang === 'true'}
                      onChange={checked => {
                        setFieldValue('isMultiLang', String(checked));
                        setIsMultiLangFlag(checked);
                      }}
                    />
                  </Col>
                  {/* Category default  */}
                  <Col xs={24}>
                    <FormInput
                      name={`category${DEFAULT_LANG.value}`}
                      label={`Title (${DEFAULT_LANG.label})`}
                      value={values[`category${DEFAULT_LANG.value}`]}
                      handleChange={handleChange}
                      placeholder={`Category title in ${DEFAULT_LANG.label}`}
                      errors={errors}
                      touched={touched}
                    />
                  </Col>
                  {/* Category dynamic  */}
                  {values.isMultiLang === 'true' &&
                    LANGUAGE_BY_DOMAIN.filter(item => DEFAULT_LANG.value !== item[1]).map(([label, value], index) => {
                      return (
                        <Col xs={24} key={index}>
                          <FormInput
                            name={`category${value}`}
                            label={`Title (${label})`}
                            value={values[`category${value}`]}
                            handleChange={handleChange}
                            placeholder={`Category title in ${label}`}
                            errors={errors}
                            touched={touched}
                          />
                        </Col>
                      );
                    })}
                </Row>
              </div>

              <DivBreak />

              <Row justify="end" align="middle">
                <Col>
                  <Button
                    style={{
                      backgroundColor: '#155BDC',
                      color: '#fff',
                      marginRight: 5,
                      height: '40px',
                      fontWeight: '500',
                    }}
                    htmlType="submit"
                    loading={categoryLoading}
                  >
                    {values?._id ? 'Edit Category' : 'Add Category'}
                  </Button>
                  <Button size="default" type="white" key="back" outlined onClick={onCancel}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            </BasicFormWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};
FeatureCategoryForm.propTypes = {
  formData: PropTypes.object,
  onCancel: PropTypes.func,
};
export default FeatureCategoryForm;
